import MobileDetect from 'mobile-detect';

const detector = new MobileDetect(window.navigator.userAgent);

export const isMobile = () => detector.mobile();
export const isTablet = () => detector.tablet();
export const isPhone = () => detector.phone();
